import { cn } from '@heidi/utils';

export const breadcrumbListClasses = cn(
  'flex flex-wrap items-center gap-1.5 break-words text-sm text-text-secondary sm:gap-2.5'
);

export const breadcrumbItemClasses = cn('inline-flex items-center gap-1.5');

export const breadcrumbLinkClasses = cn('transition-colors hover:text-text-primary');

export const breadcrumbPageClasses = cn('font-normal text-text-primary');

export const breadcrumbSeparatorClasses = cn('[&>svg]:size-3.5');

export const breadcrumbEllipsisClasses = cn('flex size-9 items-center justify-center');
